import React from "react";
import { BackgroundImage } from "../../Components";

const Blog = (props) => {
    const { selectedLanguage } = props
    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_blog} text={selectedLanguage?.txt_feature_blog_posts} mainClass='blog-banner' />
            <div className="blog-text-div">
                <p>{selectedLanguage?.txt_no_blog_posts_are_available_at_the_moment}</p>
            </div>
        </div>
    )
}

export default Blog